var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit } from '@angular/core';
import { ToolEnum } from '../../models/tool.enum';
import { Select, Store } from '@ngxs/store';
import { EngineCameraState } from '../../state/camera/engine.camera.state';
import { Observable } from 'rxjs';
import { ZoomCamera, SetCamera, SetPanMode } from '../../state/camera/engine.camera.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { CenterCameraOnVisible } from '../../state/engine.actions';
var EngineCameraBarComponent = /** @class */ (function () {
    function EngineCameraBarComponent(store) {
        this.store = store;
        this.toolEnum = ToolEnum;
        this.showCenter = false;
    }
    EngineCameraBarComponent.prototype.ngOnInit = function () {
    };
    EngineCameraBarComponent.prototype.setZoom = function (state) {
        var zoomValue = (state === '') ? 0 : 8;
        zoomValue = (state === 'in') ? -zoomValue : zoomValue;
        this.store.dispatch(new ZoomCamera(zoomValue));
    };
    EngineCameraBarComponent.prototype.returnToChapterCamera = function () {
        var chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
        this.store.dispatch(new SetCamera(chapter.camera.location));
    };
    EngineCameraBarComponent.prototype.centerCamera = function () {
        this.store.dispatch(new CenterCameraOnVisible());
    };
    EngineCameraBarComponent.prototype.togglePan = function () {
        var mode = this.store.selectSnapshot(EngineCameraState.getPanMode) === 'pan' ? 'rotate' : 'pan';
        this.store.dispatch(new SetPanMode(mode));
    };
    __decorate([
        Select(EngineCameraState.getPanMode),
        __metadata("design:type", Observable)
    ], EngineCameraBarComponent.prototype, "panMode$", void 0);
    return EngineCameraBarComponent;
}());
export { EngineCameraBarComponent };
